export default __webpack_public_path__ + "kerika-logo.e3c1813f.svg";